import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { Row, Col } from 'reactstrap';
import styled, { css } from 'styled-components';
import C3Chart from './C3Chart';
import 'c3/c3.css';

import './InfoPais.css';
import { SSemiFixedContainer, SFixed, SScrollStretch } from './SemifixedLayout';

export class InfoPais extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pais: props.pais,
      atributoSeleccionado: props.atributoSeleccionado
    };
    this.atrSel = props.atributoSeleccionado;
  }

  render() {
    const t = this.props.t;
    // this.atrSel = this.state.atributoSeleccionado;
    const pais = this.state.pais;
    const xs = 12;
    const SCrest = this.SCrest;
    const SFlag = this.SFlag;
    const SOpciones = this.SOpciones;
    return (
      <SSemiFixedContainer className={this.props.className} style={this.props.style}>
        <SFixed>
          <Col xs={12} className="d-flex flex-column">
            <SCrest
              src={
                pais
                  ? `${this.props.baseUrl}/img/escudos/${pais.fifa_code}.png`
                  : `${this.props.baseUrl}/img/escudos/escudoVacio.svg`
              }
              alt={
                pais
                  ? t('Escudo de') + ' ' + t(pais.seleccion) + '.'
                  : t('País no seleccionado') + '.'
              }
            />
            <h1 className="align-self-center" style={{ textAlign: 'center' }}>
              <SFlag
                src={`${this.props.baseUrl}/img/banderas/${
                  pais ? pais.iso_code : 'banderaVacia'
                }.svg`}
                alt={
                  pais
                    ? t('Bandera de') + ' ' + t(pais.seleccion) + '.'
                    : t('País no seleccionado') + '.'
                }
              />
              {t(pais ? pais.seleccion : 'Seleccione un país')}
            </h1>
          </Col>
          <Col xs={xs} className="d-flex flex-column align-items-center">
            {pais && (
              <h2>
                {t('Grupo')} {pais.grupo2018}
              </h2>
            )}
          </Col>
        </SFixed>
        <SScrollStretch>
          <SOpciones pais={pais} t={t} />
        </SScrollStretch>
      </SSemiFixedContainer>
    );
  }

  renderChart(pais, años, t) {
    let data = {
      x: 'x',
      columns: [['x', 2018], ['y', 0]],
      type: 'bar'
    };
    if (pais) {
      años = pais.mejorPosicion.años;
      data = {
        x: 'x',
        columns: [['x', ...años], ['y', ...Array(años.length).fill(1)]],
        type: 'bar'
      };
    }

    const mountNode = document.getElementById('chart-c3-mejor-posicion');

    ReactDOM.render(
      <C3Chart
        size={{ height: 60 }}
        data={data}
        bar={{ width: { ratio: 0.3 } }}
        axis={{
          x: {
            show: true,
            label: {
              text: t('Año'),
              position: 'outer-middle'
            }
          },
          y: {
            show: false
          }
        }}
        legend={{ show: false }}
        tooltip={{ show: false }}
      />,
      mountNode
    );
  }

  componentDidMount() {
    const pais = this.state.pais;
    let años = [];
    const t = this.props.t;
    this.renderChart(pais, años, t);
  }

  componentDidUpdate() {
    const pais = this.state.pais;
    let años = [];
    const t = this.props.t;
    this.renderChart(pais, años, t);
  }

  componentWillReceiveProps = nextProps => {
    this.setState({ pais: nextProps.pais, atributoSeleccionado: nextProps.atributoSeleccionado });
  };
  handleAttributeChange = attr => {
    this.props.onAtributoChange(attr);
  };
  Opcion = ({ className, children, valor }) => (
    <Col
      xs={12}
      className={className}
      onMouseEnter={e => {
        this.handleAttributeChange(valor);
      }}
      onMouseLeave={e => {
        this.handleAttributeChange(this.atrSel);
      }}
      onClick={e => {
        this.handleAttributeChange(valor);
        this.atrSel = valor;
      }}
    >
      <Row>{children}</Row>
    </Col>
  );
  Opciones = ({ className, xs = 6, md = 6, lg = 6, pais, t }) => {
    const SOpcion = this.SOpcion;
    let descripcionVecesMejorPosicion = null;
    if (pais) {
      const vecesMejorPosicion = pais.mejorPosicion.años.length;
      descripcionVecesMejorPosicion = '';
      if (vecesMejorPosicion === 0) {
        descripcionVecesMejorPosicion = '';
      } else {
        descripcionVecesMejorPosicion = (
          <div>
            {t(`${vecesMejorPosicion}veces`)}
            <br />
          </div>
        );
      }
    }
    return (
      <div className={className}>
        <SOpcion valor="mejorPosicion">
          <Col xs={xs} md={md}>
            <strong>{t('mejorPosicion')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? descripcionVecesMejorPosicion : ''}
            {t(pais ? pais.mejorPosicion.nombre : '')}
          </Col>
          <Col xs={12}>
            <div id="chart-c3-mejor-posicion" />
          </Col>
        </SOpcion>
        <SOpcion valor="mundialesJugados">
          <Col xs={xs} md={md}>
            <strong>{t('mundialesJugados')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? pais.mundialesJugados : ''}
          </Col>
        </SOpcion>
        <SOpcion valor="partidosJugados">
          <Col xs={xs} md={md}>
            <strong>{t('partidosJugados')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? pais.partidosJugados : ''}
          </Col>
        </SOpcion>
        <SOpcion valor="pg">
          <Col xs={xs} md={md}>
            <strong>{t('pg')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? pais.pg : ''}
          </Col>
        </SOpcion>
        <SOpcion valor="pe">
          <Col xs={xs} md={md}>
            <strong>{t('pe')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? pais.pe : ''}
          </Col>
        </SOpcion>
        <SOpcion valor="pp">
          <Col xs={xs} md={md}>
            <strong>{t('pp')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? pais.pp : ''}
          </Col>
        </SOpcion>
        <SOpcion valor="puntos">
          <Col xs={xs} md={md}>
            <strong>{t('puntos')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? pais.puntos : ''}
          </Col>
        </SOpcion>
        <SOpcion valor="golesAFavor">
          <Col xs={xs} md={md}>
            <strong>{t('golesAFavor')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? pais.golesAFavor : ''}
          </Col>
        </SOpcion>
        <SOpcion valor="golesEnContra">
          <Col xs={xs} md={md}>
            <strong>{t('golesEnContra')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? pais.golesEnContra : ''}
          </Col>
        </SOpcion>
        <SOpcion valor="tiemposExtraJugados">
          <Col xs={xs} md={md}>
            <strong>{t('tiemposExtraJugados')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? pais.tiemposExtraJugados : ''}
          </Col>
        </SOpcion>
        <SOpcion valor="tandasDePenal">
          <Col xs={xs} md={md}>
            <strong>{t('tandasDePenal')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? pais.tandasDePenal : ''}
          </Col>
        </SOpcion>
        <SOpcion valor="golFavorTandaPenales">
          <Col xs={xs} md={md}>
            <strong>{t('golFavorTandaPenales')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? pais.golFavorTandaPenales : ''}
          </Col>
        </SOpcion>
        <SOpcion valor="golContraTandaPenales">
          <Col xs={xs} md={md}>
            <strong>{t('golContraTandaPenales')}</strong>
          </Col>
          <Col xs={xs} md={md}>
            {pais ? pais.golContraTandaPenales : ''}
          </Col>
        </SOpcion>
      </div>
    );
  };
  SOpcion = styled(this.Opcion)`
    word-wrap: break-word;
    cursor: pointer;
    /* transition: 0.05s border-color; */
    /* padding: 2px; */
    padding: 10px;
    border-style: solid;
    border-width: 2px;
    border-color: #fff;
    transition: border-color 0.5s ease-in-out;

    ${props =>
      (this.atrSel === props.valor || this.state.atributoSeleccionado === props.valor) &&
      css`
        border-color: #000;
      `};
  `;
  SOpciones = styled(this.Opciones)``;
  SCrest = styled.img`
    width: 100%;
    height: auto;
    max-height: 15em;
    padding: 2em;
    margin: none;
    align-self: center;
    object-fit: contain;
  `;
  SFlag = styled.img`
    display: inline;
    width: auto;
    height: 1em;
    border: 1px solid black;
  `;
}



// WEBPACK FOOTER //
// ./src/components/InfoPais.js